import React from 'react';
// material-ui
import { Box, Button, Grid } from '@mui/material';
// request
import { apiManage_rbp } from '../../request';
// component
import MenuListComponent, { ContextMenuKey, MenuListItem } from './menu-list/menu-list-component';
import SecondMenuDetail from './second-menu-detail.component';
import FirstMenuDetail from './first-menu-detail.component';
// type
import { Condiments, FirstMenu, ItemUnit, MenuDish, SecondMenu, TaxGroup } from '../../models';
// function
import _ from 'lodash';
import DialogComponent from '../../component/dialog/dialog.component';
import CommonInput from '../../component/form/common-input.component';
import './scss/menu-dish-maker-page.scss';
import i18n from '../../i18n';
import SearchComponent from './search.component';
import AllDishList from './all-dish-list.component';
import GlobalNotification from '../../component/common/snackbar';
import setLoading from '../../component/linear-determinate';
import ClassifyMenuLibrary from './classify-menu-library.component';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import LSM from '../../modules/cache/tool-local-storage';
import ButtonComponent from '../../component/button/button.component';
import { LoadingInsert } from '../main/main-page-states';
import AlertDialog from '../../component/dialog/alert-dialog.component';
import BaseInput from '../../component/form/base-input.component';
import { DropResult } from 'react-beautiful-dnd';

enum MENU_ACTION_TYPE {
    'ADD' = 'ADD',
    'SUB_ADD' = 'SUB_ADD',
    'UP' = 'UP',
    'DOWN' = 'DOWN',
    'COPY_FIRST' = 'COPY_FIRST',
    'COPY_SECOND' = 'COPY_SECOND',
}

class MenuDishMakerComponent extends React.Component<Props, State> {
    public menuRef: React.RefObject<any> | null = React.createRef()
    public searchRef: React.RefObject<any> | null = React.createRef()
    public state: State = {
        // 服务器地址
        serverUrl: LSM.get(LOCAL_STORAGE_KEYS.SERVER_URL),
        // 菜单数据（含菜品，供套餐选择菜品使用）
        menuListForSet: [],
        // 菜单数据
        menuData: [],
        // 选择中的二级菜单下的菜品
        activeSecondMenuDishes: {},
        // 选择中的一级菜单下的二级菜单(含菜品)
        activeFirstMenuDishes: {},
        // 额外费用菜单 菜品形式
        extraMenuData: [],
        // 额外费用菜单数据 菜单形式
        extraResult: [],
        // 是否显示确认弹框
        isShowConfirmDialog: false,
        // 当前点击菜单数据源
        currentMenuDataSource: {} as any,
        // 当前点击菜单下标
        currentMenuIndex: -1,
        // 是否显示新增菜单确认弹框
        isShowCreateMenuDialog: false,
        // 是否显示基础菜品库弹窗
        isShowClassifyMenuLibrary: false,
        // 新增菜单名称
        newMenuValue: '',
        // 当前操作key值（用于区分同级新增与下级新增）
        actionKey: undefined,
        // 当前选中菜单key值 (用于控制菜单选中样式)
        activeMenuKey: '',
        // 当前选中菜单的index值 (用于操作菜单增删后数组元素位置的变化)
        activeMenuIndexNum: -1,
        // 税率组列表
        taxGroup: [],
        // 菜品规格列表
        priceSpecList: [],
        // 加载中 初次加载时候使用
        isLoading: true,
        // 调味品组
        condimentsGroup: [],
        // 打印组列表
        printGroup: [],
        // 报表主类别
        majorGroup: [],
        // 报表子类别
        mergetypes: [],
        // 复制二级菜单到一级菜单的id
        copySecondMenuToFirstMenuId: -1,
        // 选择的平台  0为POS2.0端  1是聚客端
        selectedItemKey: 1,
        // 全部菜品列表弹窗
        isShowAllDishList: false,
    }

    public search: { isSearch: boolean; sourceMenuData: FirstMenu[]; fast_nlu: number } = {
        isSearch: false,
        sourceMenuData: [],
        fast_nlu: -1
    }

    public preMenu: FirstMenu[] = [];
    // 菜单数据，用于“复制”“转移”时的菜单列表
    public originMenu: FirstMenu[] = [];

    // *********************
    // Life Cycle Function
    // *********************
    public async componentDidMount() {
        await this.init()
        // 没有下标 自动修改下标
        await this.patchFirstMenuIndex()
        this.setState({
            isLoading: false
        })
        // 菜单数据（含菜品，供套餐选择菜品使用）
        // await this.initMenuList();
    }

    // *********************
    // Default Function
    // *********************

    // 初始化
    public async init() {
        try {
            setLoading(true);

            const menuDataApi = this.getMenuData({ first: true });
            const printGroupApi = this.getPrintClass();
            const taxGroupApi = this.getTaxGroup();
            const extraMenuDataResultApi = this.getExtraMenuData();
            const condimentsGroupApi = this.getCondimentsGroup();
            const priceSpecListApi = this.getPriceSpecification();
            const majorGroupApi = this.getMajorGroup();
            const mergetypesApi = this.getMergetypes();
            const api23Api = apiManage_rbp.getSettingById(23);

            const [menuData, printGroup, taxGroup, extraMenuDataResult,
                condimentsGroup, priceSpecList, majorGroup, mergetypes, api23] = await Promise.all(
                    [menuDataApi, printGroupApi, taxGroupApi, extraMenuDataResultApi,
                        condimentsGroupApi, priceSpecListApi, majorGroupApi, mergetypesApi, api23Api]
                )

            this.setState({
                extraMenuData: extraMenuDataResult.extraMenuData,
                extraResult: extraMenuDataResult.extraResult,
                menuData,
                activeMenuIndex: menuData.length > 0 ? '[0]' : '',
                activeMenuKey: `${_.get(menuData, '[0].main_group_id', '')}`,
                taxGroup,
                condimentsGroup,
                printGroup,
                priceSpecList,
                majorGroup,
                mergetypes
            })

            this.search.fast_nlu = _.get(api23, '[0].value', -1)
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    /**
     * 菜单数据（含菜品，供套餐选择菜品使用）
     */
    public async initMenuList() {

        const result = await apiManage_rbp.get_menus_v3({
            type: 0,
            with_dish: true,
            rbpSort: 1,
        })
        if (!_.get(result, 'error')) {
            this.setState({
                menuListForSet: result,
            });
        }

    }

    /**
     * 获取菜品规格列表
     */
    public async getPriceSpecification() {
        const result = await apiManage_rbp.getPriceSpecification();
        if (!_.get(result, 'error')) {
            return result
        } else {
            return []
        }
    }

    /**
     * 获取打印组列表 （对应KWA岗位）
     */
    public async getPrintClass() {
        const none = {
            print_class_id: -1,
            print_class_name: i18n.t('print_setting_page_none0')
        }
        const result = await apiManage_rbp.getPrinterClass();
        if (!_.get(result, 'error')) {
            return [none, ...result]
        }
        return [none]
    }

    /**
     * 获取税率组列表
     */
    public async getTaxGroup() {
        const result = await apiManage_rbp.get_tax_group();
        if (!_.get(result, 'error')) {
            return result
        }
        return []
    }

    /**
     * 获取调味品列表
     */
    public async getCondimentsGroup() {
        const none = {
            scomdiment_groups_id: -1,
            comdiment_groups_name: i18n.t('print_setting_page_none0'),
            comdiments: undefined,
        }
        const result = await apiManage_rbp.get_condiments_group({
            with_group: true
        });
        if (!_.get(result, 'error')) {
            const res = result.map((item) => ({
                ...item,
                comdiments: undefined,
            }));
            return [none, ...res]
        }
        return [none]
    }
    /**
     * 获取报表主类别
     */
    public async getMajorGroup() {
        const none = {
            major_group_id: -1,
            major_group_name: i18n.t('print_setting_page_none0')
        }
        const result = await apiManage_rbp.getDishReportLabel();
        if (!_.get(result, 'error')) {
            return [none, ...result]
        }
        return [none]
    }
    /**
     * 获取报表子类别
     */
    public async getMergetypes() {
        const none = {
            family_group_id: -1,
            family_group_name: i18n.t('print_setting_page_none0')
        }
        const result = await apiManage_rbp.getDishPostLabel();
        if (!_.get(result, 'error')) {
            return [none, ...result]
        }
        return [none]
    }

    /**
     * 获取菜单
     */
    public async getMenuData(params?: { with_dish?: boolean, activeMenuKey?: string, first?: boolean }) {
        const result = await apiManage_rbp.get_menus_v3({
            type: 0,
            with_dish: params?.with_dish ?? false,
            rbpSort: 1,
        })
        this.search.isSearch = false;
        this.searchRef?.current?.setState({ inputSearchValue: '' });
        // 不需要等,供套餐选择菜品使用
        this.initMenuList();
        if (!_.get(result, 'error')) {
            this.preMenu = [...result];
            this.originMenu = [...result];
            const list = this.state.selectedItemKey === 0 ? result : result.sort((a, b) => {
                return Number(a.main_group_id) - Number(b.main_group_id);
            });
            await this.getSecondMenuDishes(params?.first ? `${_.get(list, '[0].main_group_id', '')}` : params?.activeMenuKey);
            return list
        }
        else {
            return []
        }
    }
    /**
     * 获取额外费用菜单
     */
    public async getExtraMenuData() {
        // 获取额外费用
        const extraResult = await apiManage_rbp.get_menus_v3({
            type: 1,
            with_dish: true,
        });

        if (!_.get(extraResult, 'error')) {
            const extraMenuData: MenuDish[] = [];
            for (const v of extraResult) {
                for (const v1 of v.menu_item_slu || []) {
                    for (const v2 of v1.menu_item || []) {
                        extraMenuData.push(v2)
                    }
                }
            }
            return { extraMenuData, extraResult }

        }
        return { extraMenuData: [], extraResult: [] }
    }

    /**
     * 获取二级菜单下的菜品
     */
    public async getSecondMenuDishes(activeMenuKey?: string,) {
        const newActiveMenuKey = activeMenuKey ?? this.state.activeMenuKey;
        // 点击二级菜单
        if (newActiveMenuKey.indexOf('sub-') !== -1) {
            const secondMenuId = Number(newActiveMenuKey.split('sub-')?.[1]);
            if (this.search.isSearch) {
                const { activeMenuIndex, menuData } = this.state
                this.setState({ activeSecondMenuDishes: _.get(menuData, (activeMenuIndex as string).slice(1, -1)) });
                return
            }
            const secondMenu = await apiManage_rbp.get_second_menus_v3({ id: Number(secondMenuId) });
            if (secondMenu && secondMenu.length > 0) {
                this.setState({ activeSecondMenuDishes: secondMenu?.[0] || {} });
            }
        } else {
            if (this.search.isSearch) {
                const { activeMenuIndex, menuData } = this.state
                this.setState({ activeFirstMenuDishes: _.get(menuData, (activeMenuIndex as string).slice(1, -1)) });
                return
            }
            const firstMenuId = Number(newActiveMenuKey);
            const firstMenu = await apiManage_rbp.get_menus_v3({
                with_dish: true,
                main_group_id: firstMenuId
            })
            if (firstMenu && firstMenu.length > 0) {
                this.setState({ activeFirstMenuDishes: firstMenu?.[0] || {} });
            }
        }
    }


    /**
     * 点击菜单
     * @param menuData
     * @param index
     */
    async handleClick(menuData: MenuListItem, index: string) {
        let activeMenuIndex = `[${index}]`;
        const { dataSource, ...activeMenuData } = menuData;
        // 二级菜单
        if (!menuData.children) {
            activeMenuIndex = activeMenuIndex.replace('.', '.menu_item_slu');
        }
        else {
            // 没有下标自动修改下标
            this.patchSecondMenuIndex(dataSource.menu_item_slu)
        }
        this.setState({
            activeMenuIndex: '',
            activeMenuData: undefined,
            activeFirstMenuDishes: {}
        }, async () => {
            this.setState({
                activeMenuIndex,
                activeMenuData,
                activeMenuKey: activeMenuData.key,
            }, async () => {
                LoadingInsert(async () => await this.getSecondMenuDishes());
            })
        })
    }

    /**
     * 右键点击事件处理
     * @param menu
     * @param index
     * @param key
     */
    handleMenuClick(key: ContextMenuKey, menu: MenuListItem, index: number) {
        switch (key) {
            // 新增同级
            case 'ADD': {
                this._handleAddMenuAction(MENU_ACTION_TYPE.ADD, menu, index);
                return;
            }
            // 新增下级
            case 'SUB_ADD': {
                this._handleAddMenuAction(MENU_ACTION_TYPE.SUB_ADD, menu, index);
                return;
            }
            // 复制一级大类
            case 'COPY_FIRST': {
                this._handleAddMenuAction(MENU_ACTION_TYPE.COPY_FIRST, menu, index);
                return;
            }
            // 复制二级大类
            case 'COPY_SECOND': {
                this._handleAddMenuAction(MENU_ACTION_TYPE.COPY_SECOND, menu, index);
                this.setState({ copySecondMenuToFirstMenuId: menu.firstMenuId || -1 })
                return;
            }
            // 删除同级
            case 'DELETE': {
                this._handleDeleteSameLevelMenu(menu, index);
                return;
            }
            // 下移菜单
            case 'DOWN': {
                this._handleUpdateMenuIndex(MENU_ACTION_TYPE.DOWN, menu, index);
                return;
            }
            // 上移菜单
            case 'UP': {
                this._handleUpdateMenuIndex(MENU_ACTION_TYPE.UP, menu, index);
                return;
            }
        }
    }

    /**
     * ！ 右键新增菜单
     * @param key
     * @param menu
     * @param index
     */
    public _handleAddMenuAction(key: MENU_ACTION_TYPE, menu: MenuListItem, index: number) {
        this.setState({
            currentMenuDataSource: menu,
            currentMenuIndex: index,
            isShowCreateMenuDialog: true,
            actionKey: key,
            newMenuValue: i18n.t('global_text_Menu')
        })
    }

    /**
     * $ 新增同级菜单
     * 1. 判断菜单是一级还是二级
     * 2. 调用对应新增接口
     */
    public async _handleAddSameLevelMenu() {
        const { newMenuValue } = this.state
        const menu = _.cloneDeep(this.state.currentMenuDataSource)
        const index = _.cloneDeep(this.state.currentMenuIndex)
        if (menu) {
            const { children } = menu
            if (children) {
                // $ 一级菜单
                await this.handleAddFirstMenu(menu, index)
            } else {
                // $ 二级菜单
                await this.handleAddSecondMenu(menu, index)
            }
        } else {
            // 如果menu为null,则说明当前列表无任何菜单
            const newFirstMenu: FirstMenu = {
                main_group_name: newMenuValue,
                menu_item_slu: [],
                main_group_index: 0,
            }
            const result = await apiManage_rbp.post_create_first_menu(newFirstMenu)
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData({ activeMenuKey: `${result?.insertId}` });
                this.setState({
                    menuData,
                    activeMenuIndex: `[${0}]`,
                    activeMenuKey: `${result.insertId}`
                })
            }
        }
    }

    /**
     * $ 新增下级菜单
     * - 新增的二级菜单放在首位
     */
    public async _handleAddNextLevelMenu() {
        try {
            const menu = _.cloneDeep(this.state.currentMenuDataSource)
            const index = _.cloneDeep(this.state.currentMenuIndex)
            const { newMenuValue } = this.state
            const { dataSource, children } = menu
            // 当前一级菜单下标
            const { main_group_id, max_index } = dataSource
            // 二级菜单下标
            let dmiSluIndex: number = -1;
            if ((children as MenuListItem[]).length > 0) {
                // 如果children数组长度大于0，说明该一级菜单下存在二级菜单
                // - 新增二级菜单下标取children数组最小下标
                const secondMenuArr = (children as MenuListItem[]).sort((a, b) => {
                    return a.dataSource.dmi_slu_index - b.dataSource.dmi_slu_index
                })
                dmiSluIndex = secondMenuArr[0].dataSource.dmi_slu_index
            } else {
                // 反之，不存在二级菜单
                // - 新增二级菜单下标取max_index
                dmiSluIndex = max_index + 1
            }
            // $ 发起新增请求
            const newSecondMenu: SecondMenu = {
                dmi_slu_name: newMenuValue,
                dmi_slu_index: dmiSluIndex,
            }
            const result = await apiManage_rbp.post_create_second_menu(main_group_id as number, newSecondMenu);
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData({ activeMenuKey: `sub-${result.insertId}` });
                GlobalNotification.success(i18n.t('global_text_operate_success'))
                this.setState({
                    menuData,
                    activeMenuIndex: `[[${index}].menu_item_slu[0]]`,
                    activeMenuKey: `sub-${result.insertId}`
                })
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }

    /**
     * $ 一级菜单大类复制操作
     * ? 暂定复制后的菜单在末尾
     * @returns
     */
    public _handleCopyFirstMenu = async () => {
        try {
            const { newMenuValue, currentMenuDataSource } = this.state
            const menu = _.cloneDeep(currentMenuDataSource)
            const { dataSource } = menu
            // 组合参数
            const copyParams = {
                id: dataSource?.main_group_id,
                name: newMenuValue
            }
            const result = await apiManage_rbp.patch_copy_menu(copyParams);
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData({ activeMenuKey: `${result?.main_group_id}`, with_dish: true });
                GlobalNotification.success(i18n.t('global_text_operate_success'))
                this.setState({
                    menuData,
                    activeMenuIndex: `[[${menuData?.length - 1}]]`,
                    activeMenuKey: `${result?.main_group_id}`
                })

                // 获取原一级菜单图片
                // await urlToFile(`${serverUrl}/menu/${dataSource?.main_group_id}.jpg?v=${Date.now()}`, false)
                //     .then(async (blob) => {
                //         // 更新复制后的一级菜单图片
                //         if (!!blob.size) await apiManage_rbp.post_image_first_menu(result?.main_group_id, blob as File)
                //         let source: FirstMenu | null = null
                //         let target: FirstMenu | null = null
                //         menuData.find(item => {
                //             if (item.main_group_id === dataSource?.main_group_id) {
                //                 source = item
                //             } else if (item.main_group_id === result?.main_group_id) {
                //                 target = item
                //             }
                //             return source && target
                //         })
                //         if (source && target) {
                //             const getImageBinaryPromise: { req: () => Promise<any>, itemId: number }[] = [];
                //             (source as FirstMenu).menu_item_slu?.forEach((secondMenu, secondIndex) => {
                //                 secondMenu.menu_item?.forEach((item, itemIndex) => {
                //                     // 先获取原来的图片
                //                     getImageBinaryPromise.push({
                //                         req: () => urlToFile(`${serverUrl}/${item.item_id}.jpg?v=${Date.now()}`),
                //                         itemId: target!.menu_item_slu![secondIndex]!.menu_item![itemIndex]!.item_id as number
                //                     })
                //                 })
                //             })
                //             const postNewImagePromises: Array<Promise<any>> = [];

                //             await Promise.allSettled(getImageBinaryPromise.map(item => item.req())).then(results => {
                //                 results.forEach((res, index) => {
                //                     if (res.status === 'fulfilled') {
                //                         // 再更新复制后的菜品图片
                //                         const itemId = getImageBinaryPromise[index].itemId
                //                         postNewImagePromises.push(apiManage_rbp.post_dishes_image(`${itemId},${itemId}_s`, res.value as File))
                //                     }
                //                 })
                //             })

                //             await Promise.all(postNewImagePromises)
                //         }
                //     })
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }

    /**
     * $ 二级菜单大类复制操作
     * ? 暂定复制后的菜单在末尾
     * @returns
     */
    public _handleCopySecondMenu = async () => {
        try {
            const { newMenuValue, copySecondMenuToFirstMenuId, currentMenuDataSource } = this.state
            const menu = _.cloneDeep(currentMenuDataSource)
            const { dataSource, firstMenuId, firstMenuIndex } = menu
            // 组合参数
            const copyParams = {
                id: dataSource?.dmi_slu_id as number,
                main_group_id: copySecondMenuToFirstMenuId as number,
                name: newMenuValue,
            }
            const result = await apiManage_rbp.patch_copy_second_menu(copyParams);
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData({ activeMenuKey: `sub-${result.dmi_slu_id}`, with_dish: true });
                // 获取当前一级菜单下的二级菜单数量
                const sluLen: number =
                    menuData?.find(n => n.main_group_id === firstMenuId)?.menu_item_slu?.length ?? 0;
                GlobalNotification.success(i18n.t('global_text_operate_success'))
                this.setState({
                    menuData,
                    activeMenuIndex: `[[${firstMenuIndex}].menu_item_slu[${sluLen - 1}]]`,
                    activeMenuKey: `sub-${result.dmi_slu_id}`
                })

                // 原菜单
                let source: SecondMenu | null = null
                // 复制后的二级菜单
                let target: SecondMenu | null = null
                menuData.find(item => {
                    if (item.main_group_id === currentMenuDataSource.firstMenuId) {
                        item.menu_item_slu?.find(secondMenu => {
                            if (secondMenu.dmi_slu_id === dataSource?.dmi_slu_id) {
                                // 原要复制的一级菜单下二级菜单的菜品数据
                                source = secondMenu
                                return true
                            }
                            return false
                        })
                    }
                    if (item.main_group_id === copySecondMenuToFirstMenuId) {
                        item.menu_item_slu?.find(secondMenu => {
                            if (secondMenu.dmi_slu_id === result.dmi_slu_id) {
                                // 复制后的二级菜单下的菜品数据
                                target = secondMenu
                                return true
                            }
                            return false
                        })
                    }
                    return source && target
                })
                if (source && target) {
                    // const getImageBinaryPromise: { req: () => Promise<any>, itemId: number }[] = [];
                    // (source as SecondMenu).menu_item?.forEach((item, itemIndex) => {
                    //     // 先获取原来的图片
                    //     getImageBinaryPromise.push({
                    //         req: () => urlToFile(`${serverUrl}/${item.item_id}.jpg?v=${Date.now()}`),
                    //         itemId: target!.menu_item![itemIndex]!.item_id as number
                    //     })
                    // })

                    // const postNewImagePromises: Array<Promise<any>> = [];
                    // await Promise.allSettled(getImageBinaryPromise.map(item => item.req())).then(results => {
                    //     results.forEach((res, index) => {
                    //         if (res.status === 'fulfilled') {
                    //             // 再更新复制后的菜品图片
                    //             const itemId = getImageBinaryPromise[index].itemId
                    //             postNewImagePromises.push(apiManage_rbp.post_dishes_image(`${itemId},${itemId}_s`, res.value as File))
                    //         }
                    //     })
                    // })

                    // await Promise.all(postNewImagePromises)

                }
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }

    /**
     * 控制确认新增菜单操作
     * - 区分同级新增、下级新增、复制菜单操作
     */
    handleConfirmCreateMenu = async () => {
        const { actionKey, newMenuValue } = this.state
        // 菜单名称不能为空
        if (!newMenuValue.trim()) { return; }

        this.setState({
            isShowCreateMenuDialog: false,
        }, async () => {
            setLoading(true);
            if (actionKey === MENU_ACTION_TYPE.ADD) {
                // $ 同级新增
                await this._handleAddSameLevelMenu()
            }

            if (actionKey === MENU_ACTION_TYPE.SUB_ADD) {
                // $ 下级新增
                await this._handleAddNextLevelMenu()
            }

            if (actionKey === MENU_ACTION_TYPE.COPY_FIRST) {
                // $ 一级菜单复制
                await this._handleCopyFirstMenu()
            }
            if (actionKey === MENU_ACTION_TYPE.COPY_SECOND) {
                // $ 二级菜单复制
                await this._handleCopySecondMenu()
            }
            setLoading(false);
            this.setState({
                actionKey: undefined,
                currentMenuDataSource: {} as any,
                currentMenuIndex: -1,
            })
        })

    }


    /**
     * ！ 删除同级菜单
     * @param menu
     * @param index
     */
    public async _handleDeleteSameLevelMenu(menu: MenuListItem, index: number) {
        this.setState({
            isShowConfirmDialog: true,
            currentMenuDataSource: menu,
            activeMenuIndexNum: index,
        })
    }

    /**
     * 删除弹窗确认 - 删除同级菜单
     * 1. 判断是菜单是一级还是二级
     * 2. 调用对应删除接口
     */
    public async handleConfirm() {
        setLoading(true)
        const { currentMenuDataSource } = this.state
        const { children } = currentMenuDataSource
        if (children) {
            // $ 一级菜单
            await this.deleteFirstMenu(currentMenuDataSource)
        } else {
            // $ 二级菜单
            await this.deleteSecondMenu(currentMenuDataSource)
        }
        setLoading(false)
    }

    /**
     * ! 更改菜单位置操作
     * 1. 判断是菜单是一级还是二级
     * 2. 调用对应删除接口
     * @param type  UP | DOWN
     * @param menu
     * @param index
     */
    public async _handleUpdateMenuIndex(type: MENU_ACTION_TYPE, menu: MenuListItem, index: number) {
        const { children } = menu
        if (children) {
            // $ 一级菜单
            await this.handlePatchFirstMenuIndex(type, menu, index)
        } else {
            // $ 二级菜单
            await this.handlePatchSecondMenuIndex(type, menu, index)
        }
    }

    /**
     * 新增一级菜单
     * @param menu
     * @param index 新增的位置
     */
    async handleAddFirstMenu(menu: MenuListItem, index: number) {
        try {
            const { newMenuValue } = this.state
            const { dataSource } = menu
            // 当前点击菜单下标
            const { main_group_index } = dataSource;
            // $ 新增一级菜单
            const newFirstMenu: FirstMenu = {
                main_group_name: newMenuValue,
                menu_item_slu: [],
                main_group_index: main_group_index + 1,
            }
            const result = await apiManage_rbp.post_create_first_menu(newFirstMenu)
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData({ activeMenuKey: `${result.insertId}` });
                this.setState({
                    menuData,
                    activeMenuIndex: `[[${index + 1}]]`,
                    activeMenuKey: `${result.insertId}`,
                })
            }

        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }

    }

    /**
     * 没有下标 自动修改下标
     */
    async patchFirstMenuIndex() {
        let hasIndex = true;
        const { menuData } = this.state;
        const menuIndexArr = menuData.map((item, index) => {
            // 判断是否有下标
            if (!(item.main_group_index || (item.main_group_index === 0))) {
                hasIndex = false;
            }
            return ({
                main_group_id: item.main_group_id,
                main_group_index: index + 1
            })
        });
        // 如果没有下标
        if (!hasIndex) {
            // 修改下标
            await apiManage_rbp.patch_change_first_menu_index(menuIndexArr)
            await this.init();
        }
    }
    /**
     * 没有下标 自动修改下标
     */
    async patchSecondMenuIndex(menuData: SecondMenu[]) {
        let hasIndex = true;
        const menuIndexArr = menuData.map((item, index) => {
            // 判断是否有下标
            if (!(item.dmi_slu_index || (item.dmi_slu_index === 0))) {
                hasIndex = false;
            }
            return ({
                dmi_slu_id: item.dmi_slu_id,
                dmi_slu_index: index + 1
            })
        });
        // 如果没有下标
        if (!hasIndex) {
            // 修改下标
            await apiManage_rbp.patch_change_second_menu_index(menuIndexArr)
            await this.init();
        }
    }

    /**
     * 删除一级菜单
     * @param menu
     */
    async deleteFirstMenu(menu: MenuListItem) {
        try {
            const { dataSource, children } = menu
            const { main_group_id } = dataSource
            const { activeMenuData, activeMenuIndexNum, activeMenuIndex, } = this.state
            // 如果一级菜单下存在二级菜单，不允许删除，需要先清空其下的二级菜单才可删除
            if ((children as MenuListItem[]).length > 0) {
                GlobalNotification.warning(i18n.t('menu_and_dishes_page_menu_have_secondary_menu_please_clear_them'))
                return
            }
            // $ 发起删除请求
            const result = await apiManage_rbp.delete_first_menu(main_group_id as number)
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData({ activeMenuKey: activeMenuData ? (activeMenuData as any).key : '' });
                // 获取activeIndex中，一级菜单下标数值
                const menuIndexNum = activeMenuIndex?.replaceAll('[', '').replaceAll(']', '')
                let currentMenuIndexNum: any = '';
                // $ 处理删除后，当前菜单选中下标赋值
                // 1. 当前选中一级菜单下标 = 右键选中一级菜单下标
                // 2. 当前选中一级菜单下标 > 右键选中一级菜单下标
                // 3. 当前选中一级菜单下标 < 右键选中一级菜单下标
                if (Number(menuIndexNum) === activeMenuIndexNum) {
                    currentMenuIndexNum = undefined
                } else if (Number(menuIndexNum) > activeMenuIndexNum) {
                    currentMenuIndexNum = `[[${Number(menuIndexNum) - 1}]]`
                } else {
                    currentMenuIndexNum = activeMenuIndex
                }
                // 删除一级菜单图片
                // 先获取一级菜单图片
                // await urlToFile(`${serverUrl}/menu/${dataSource?.main_group_id}.jpg?v=${Date.now()}`, false)
                //     .then(async (blob) => {
                //         if (!!blob.size) {
                //             // 删除一级菜单图片
                //             await apiManage_rbp.delete_first_menu_image(main_group_id);
                //         }
                //     })
                this.setState({
                    menuData,
                    activeMenuKey: activeMenuData ? (activeMenuData as any).key : '',
                    activeMenuIndex: currentMenuIndexNum
                })
                GlobalNotification.success(i18n.t('global_text_operate_success'))
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        } catch (error) {
            console.log('error', error)
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }

    /**
     * 新增二级菜单
     * @param menu
     * @param index
     */
    async handleAddSecondMenu(menu: MenuListItem, index: number) {
        try {
            const { newMenuValue } = this.state
            const { dataSource, firstMenuId, firstMenuIndex } = menu
            // 当前二级菜单下标
            const { dmi_slu_index } = dataSource
            // $ 发起新增请求
            const newSecondMenu: SecondMenu = {
                dmi_slu_name: newMenuValue,
                dmi_slu_index: dmi_slu_index + 1,
            }
            const result = await apiManage_rbp.post_create_second_menu(firstMenuId as number, newSecondMenu);
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData({ activeMenuKey: `sub-${result.insertId}` });
                this.setState({
                    menuData,
                    activeMenuIndex: `[[${firstMenuIndex}].menu_item_slu[${index + 1}]]`,
                    activeMenuKey: `sub-${result.insertId}`
                })
                GlobalNotification.success(i18n.t('global_text_operate_success'))
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }
    }

    /**
     * 删除二级菜单
     * @param menu
     */
    async deleteSecondMenu(menu: MenuListItem) {
        try {
            const { activeMenuIndexNum, activeMenuIndex, menuListForSet } = this.state
            const { dataSource, firstMenuId } = menu
            const { dmi_slu_id } = dataSource
            // 如果一级菜单下存在菜品，不允许删除，需要先清空其下的所有菜品才可删除
            let hasChild = false

            menuListForSet.forEach(firstMenu => {
                firstMenu.menu_item_slu?.forEach(secondMenu => {
                    if (secondMenu.dmi_slu_id === dmi_slu_id && secondMenu?.menu_item?.length) {
                        hasChild = true
                    }
                })
            })

            if (hasChild) {
                GlobalNotification.warning(i18n.t('menu_and_dishes_page_menu_and_dishes_page_menu_under_have_dish_please_clear_them'))
                return
            }
            // $ 发起删除请求
            const result = await apiManage_rbp.delete_second_menu(dmi_slu_id as number, firstMenuId as number)
            if (!_.get(result, 'error')) {
                // 刷新数据
                const menuData = await this.getMenuData();
                // 获取activeIndex中，一二级菜单下标数值
                const menuIndexNums =
                    activeMenuIndex?.replaceAll('[', '').replaceAll(']', '').replace('menu_item_slu', '').split('.')
                // 一级菜单下标数值
                const firstMenuIndexNum: any = (menuIndexNums as any)[0];
                // 二级菜单下标数值（若为undefined,则当前没有选中二级菜单）
                const secondMenuIndexNum: any = (menuIndexNums as any)[1] || undefined;
                let currentMenuIndexNum: any = '';
                // $ 处理删除后，当前菜单选中下标赋值
                // 1. 当前选中二级菜单下标 = 右键选中二级菜单下标
                // 2. 当前选中二级菜单下标 > 右键选中二级菜单下标
                // 3. 当前选中二级菜单下标 < 右键选中二级菜单下标
                // 4. 二级菜单下标为undefined，说明当前没有选中的二级菜单详情
                if (Number(secondMenuIndexNum) === activeMenuIndexNum && Number(firstMenuIndexNum) === firstMenuId) {
                    currentMenuIndexNum = undefined
                } else if (Number(secondMenuIndexNum) > activeMenuIndexNum) {
                    currentMenuIndexNum = `[[${Number(firstMenuIndexNum)}].menu_item_slu[${Number(secondMenuIndexNum) - 1}]]`
                } else if (Number(secondMenuIndexNum) < activeMenuIndexNum) {
                    currentMenuIndexNum = `[[${Number(firstMenuIndexNum)}].menu_item_slu[${Number(secondMenuIndexNum)}]]`
                } else {
                    currentMenuIndexNum = activeMenuIndex
                }
                this.setState({
                    menuData,
                    activeMenuIndex: currentMenuIndexNum
                })
                GlobalNotification.success(i18n.t('global_text_operate_success'))
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }

    }

    /**
     * 更新一级菜单位置 - 上移、下移操作
     * @param type  UP | DOWN
     * @param menu
     * @param index
     */
    async handlePatchFirstMenuIndex(type: MENU_ACTION_TYPE, menu: MenuListItem, currentIndex: number) {
        try {
            setLoading(true)

            const { menuData } = this.state
            // 拷贝菜单数据源
            let _menuData = _.cloneDeep(menuData);

            // 重新排序赋值main_group_index从0开始
            _menuData = _menuData.sort((a, b) => { return Number(a.main_group_index) - Number(b.main_group_index) })
            _menuData.forEach((iitem, iindex) => {
                iitem.main_group_index = iindex;
            })

            // 前一位下标
            const targetIndex = currentIndex + (type === MENU_ACTION_TYPE.UP ? -1 : +1);
            if (targetIndex < 0) return false;

            const currnetItem = _menuData[currentIndex];
            const targetItem = _menuData[targetIndex];

            _menuData[currentIndex] = targetItem;
            _menuData[targetIndex] = currnetItem;

            //  赋值main_group_index从0开始
            _menuData.forEach((iitem, iindex) => {
                iitem.main_group_index = iindex;
            })

            // 整理请求参数
            const menuIndexArr = _menuData.map((menu: FirstMenu) => {
                const obj = {
                    main_group_id: menu.main_group_id,
                    main_group_index: menu.main_group_index,
                }
                return obj
            })
            // $ 发起请求
            const result = await apiManage_rbp.patch_change_first_menu_index(menuIndexArr)
            if (!_.get(result, 'error')) {
                this.preMenu = _menuData;
                this.setState({
                    menuData: _menuData,
                    activeMenuKey: `${menu.key}`,
                    activeMenuIndex: `[[${targetIndex}]]`,
                    activeFirstMenuDishes: _.get(_menuData, targetIndex)

                })
                GlobalNotification.success(i18n.t('global_text_operate_success'))
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }

    }

    /**
     * 更新二级菜单位置 - 上移、下移操作
     * @param type  UP | DOWN
     * @param menu
     * @param index
     */
    async handlePatchSecondMenuIndex(type: MENU_ACTION_TYPE, menu: MenuListItem, currentIndex: number) {
        try {
            setLoading(true)
            const { firstMenuId, dataSource } = menu;
            const { menuData, menuListForSet } = this.state;

            // 获取当前二级菜单所属二级菜单数组
            const filterIndex = menuData.findIndex((item: FirstMenu) => {
                return item.main_group_id === firstMenuId
            })
            if (filterIndex === -1) return false;
            // 二级菜单数组
            let _menuItemSluArr = _.get(menuData[filterIndex], 'menu_item_slu') as SecondMenu[];
            // 重新排序赋值main_group_index从0开始
            _menuItemSluArr = _menuItemSluArr.sort((a, b) => { return Number(a.dmi_slu_index) - Number(b.dmi_slu_index) })
            _menuItemSluArr.forEach((iitem, iindex) => {
                iitem.dmi_slu_index = iindex;
            })

            // 前一位下标
            const targetIndex = currentIndex + (type === MENU_ACTION_TYPE.UP ? -1 : +1);
            if (targetIndex < 0) return false;

            const currnetItem = _menuItemSluArr[currentIndex];
            const targetItem = _menuItemSluArr[targetIndex];

            _menuItemSluArr[currentIndex] = targetItem;
            _menuItemSluArr[targetIndex] = currnetItem;

            //  赋值main_group_index从0开始
            _menuItemSluArr.forEach((iitem, iindex) => {
                iitem.dmi_slu_index = iindex;
            })

            // 赋值排序后的二级菜单
            menuData[filterIndex].menu_item_slu = _menuItemSluArr;
            // 过滤菜单数组字段
            const menuIndexArr = _menuItemSluArr.map((menu: SecondMenu) => {
                const obj = {
                    dmi_slu_id: menu.dmi_slu_id,
                    dmi_slu_index: menu.dmi_slu_index,
                }
                return obj
            })

            // $ 发起请求
            const result = await apiManage_rbp.patch_change_second_menu_index(menuIndexArr)
            if (!_.get(result, 'error')) {
                // 找到一级菜单带菜品的数据
                const originFirstMenu = menuListForSet.find(item => item.main_group_id === firstMenuId);
                const activeSecondMenuDishes = originFirstMenu?.menu_item_slu?.find(item => item.dmi_slu_id === dataSource.dmi_slu_id) || {};

                this.setState({
                    menuData,
                    activeMenuKey: `sub-${dataSource.dmi_slu_id}`,
                    activeMenuIndex: `[[${filterIndex}].menu_item_slu[${targetIndex}]]`,
                    activeSecondMenuDishes: activeSecondMenuDishes as SecondMenu,
                })

                GlobalNotification.success(i18n.t('global_text_operate_success'))
            } else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'))
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            GlobalNotification.error(i18n.t('global_text_operate_failure'))
        }

    }


    /**
     * 修改一级菜单
     * @param firstMenu
     * @param file 图片文件
     */
    async onChangeFirstMenu(firstMenu: FirstMenu) {
        setLoading(true);
        // 新菜单价格
        if (firstMenu?.set_item_main === '1') {
            const menuRes = await apiManage_rbp.patch_first_menu({
                main_group_name: firstMenu.main_group_name,
                main_group_id: firstMenu.main_group_id,
            });
            const result = await apiManage_rbp.patch_first_menu_day_price(firstMenu);
            // 修改成功
            if (!_.get(result, 'error') && !_.get(menuRes, 'error')) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据
                const menuData = await this.getMenuData();
                this.setState({
                    menuData
                })
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
        }
        // 旧菜单价格
        else {
            delete firstMenu.child_price;
            delete firstMenu.normal_price;
            delete firstMenu.other_price;
            // 处理extra_child、extra_normal、extra_other 字符串是null
            if (firstMenu.extra_child === 'null') {
                firstMenu.extra_child = '';
            }
            if (firstMenu.extra_normal === 'null') {
                firstMenu.extra_normal = '';
            }
            if (firstMenu.extra_other === 'null') {
                firstMenu.extra_other = '';
            }
            const result = await apiManage_rbp.patch_first_menu(firstMenu);
            // 修改成功
            if (!_.get(result, 'error') && result.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据
                const menuData = await this.getMenuData();
                this.setState({
                    menuData
                })
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
        }
        setLoading(false);
    }

    /**
     * 修改二级菜单
     * @param secondMenu
     */
    async onChangeSecondMenu(secondMenu: SecondMenu) {
        try {
            setLoading(true);
            // $ 处理参数
            // 菜单id
            const id = secondMenu.dmi_slu_id ?? -1
            // 需要修改的字段
            const params = {
                dmi_slu_name: secondMenu.dmi_slu_name ?? '',
                category_order_limit: secondMenu.category_order_limit ?? 9999
            }
            const result = await apiManage_rbp.patch_second_menu(id, params);
            // 修改成功
            if (!_.get(result, 'error') && result.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据
                const menuData = await this.getMenuData();
                this.setState({
                    menuData
                })
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            setLoading(false);
        }
        catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
            setLoading(false);
            console.log(error)
        }
    }

    /**
     * 批量更改二级菜单下所有菜品轮次限制
     * @param dishes
     */
    public async onChangeDishesTurnRule(dishes: Pick<MenuDish, 'item_id' | 'not_joining_global_limit'>[]) {
        try {
            setLoading(true);
            // $ 请求接口
            const result = await apiManage_rbp.patch_dishes(dishes, true)
            // 修改成功
            if (!_.get(result, 'error') && result.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据
                const menuData = await this.getMenuData();
                this.setState({
                    menuData
                })
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            setLoading(false);
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
            setLoading(false);
            console.log(error)
        }
    }

    /**
     * 批量转移菜品
     * @param dishes
     */
    public async onChangeDishesTransfer(dishes: Pick<MenuDish, 'item_id' | 'slu_id'>[], notRefresh?: boolean) {
        try {
            setLoading(true);
            // $ 请求接口
            const result = await apiManage_rbp.patch_dishes(dishes)
            // 修改成功
            if (!_.get(result, 'error') && result.affectedRows > 0) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据; notRefresh在列表模式，不需要重新获取数据
                if (!notRefresh) {
                    const menuData = await this.getMenuData();
                    this.setState({
                        menuData
                    })
                }
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            setLoading(false);
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
            setLoading(false);
            console.log(error)
        }
    }

    /**
     * 批量复制菜品
     * @param dishIds
     * @param secondMenuIds
     */
    public async onChangeDishesCopy(dishIds: number[], secondMenuIds: number[], secondMenu: SecondMenu[]) {
        try {
            setLoading(true);
            // $ 复制
            const result = await apiManage_rbp.patch_copy_dishes(dishIds, secondMenuIds)
            // dishIds
            let cDishIds: number[] = [];
            // 修改成功
            if (!_.get(result, 'error')) {
                // $ 修改是否受轮次限制
                const params = result?.insert_menu_item?.map((item, index) => ({
                    item_id: item.item_id,
                    not_joining_global_limit: secondMenu[Math.floor(index / (dishIds.length))].not_joining_global_limit || 0
                }))
                await apiManage_rbp.patch_dishes(params, true)
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据
                const menuData = await this.getMenuData();
                this.setState({
                    menuData
                })
                // ? 暂定 应在复制菜品接口返回处标注原菜品id
                // 根据二级菜单长度 组装菜品id用于执行图片复制
                for (const i in secondMenuIds) {
                    if (secondMenuIds[i]) {
                        cDishIds = cDishIds.concat(dishIds);
                    }
                }

                // 先获取原来的图片
                // const getImageBinaryPromise: { req: () => Promise<any>, itemId: number }[] = cDishIds.map((id, index) => ({
                //     req: () => urlToFile(`${this.state.serverUrl}/${id}.jpg?v=${Date.now()}`),
                //     itemId: result[index].insertId as number
                // }))

                // const postNewImagePromises: Array<Promise<any>> = [];
                // await Promise.allSettled(getImageBinaryPromise.map(item => item.req())).then(results => {
                //     results.forEach((res, index) => {
                //         if (res.status === 'fulfilled') {
                //             // 再更新复制后的菜品图片
                //             const itemId = getImageBinaryPromise[index].itemId
                //             postNewImagePromises.push(apiManage_rbp.post_dishes_image(`${itemId},${itemId}_s`, res.value as File))
                //         }
                //     })
                // })

                // await Promise.all(postNewImagePromises)
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            setLoading(false);
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
            setLoading(false);
            console.log(error)
        }
    }

    /**
     * 批量删除菜品
     * @param dishIds
     */
    public async handleDeleteDishes(dishIds: { item_id: number, slu_id: number }[]) {
        try {
            setLoading(true);
            // $ 请求接口
            const result = await apiManage_rbp.delete_dishes(dishIds)
            // 修改成功
            if (!_.get(result, 'error')) {
                GlobalNotification.success(i18n.t('global_text_operate_success'));
                // 刷新数据
                const menuData = await this.getMenuData();
                this.setState({
                    menuData
                })
                // dishIds.forEach(item => {
                // apiManage_rbp.delete_dishes_image(item.item_id)
                // })
            }
            else {
                GlobalNotification.error(i18n.t('global_text_operate_failure'));
            }
            setLoading(false);
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
            setLoading(false);
            console.log(error)
        }
    }

    // 刷新数据
    async refreshMenu() {
        // 刷新数据
        const menuData = await this.getMenuData();
        this.setState({
            menuData
        })
    }

    // 设置默认展开的菜单
    setDefaultExpandMenu(menuData: FirstMenu[], menu: any) {
        const { selectedItemKey } = this.state;
        // 排序后的一级菜单
        const firstSortedNewMenu = selectedItemKey === 0 ?
            menuData.sort((a, b) => {
                return Number(a.main_group_index) - Number(b.main_group_index)
            })
            :
            menuData.sort((a, b) => {
                return Number(a.main_group_id) - Number(b.main_group_id)
            })
        // 二级菜单排序
        const sortedNewMenu = firstSortedNewMenu.map(firstMenu => {
            firstMenu.menu_item_slu = firstMenu?.menu_item_slu?.sort((a, b) => {
                if (selectedItemKey) {
                    return (a?.dmi_slu_id || 0) - (b?.dmi_slu_id || 0)
                } else {
                    return (a?.dmi_slu_index || 0) - (b?.dmi_slu_index || 0)
                }
            })
            return firstMenu
        })
        // 记录左侧一级菜单
        this.preMenu = sortedNewMenu;
        // 展开二级菜单
        this.menuRef?.current.setState({
            expandValue: []
        }, () => {
            this.menuRef?.current.setState({ expandValue: [`${sortedNewMenu[0].main_group_id}`] })
        })
        this.setState({
            menuData: sortedNewMenu,
            activeMenuIndex: '',
            activeMenuData: undefined,
            activeFirstMenuDishes: {}
        }, () => {
            this.setState({
                activeMenuIndex: '[[0]]',
                activeMenuKey: `${sortedNewMenu[0].main_group_id}`,
                activeMenuData: menu[0]
            }, () => {
                this.setState({
                    activeMenuIndex: '[[0].menu_item_slu[0]]',
                    activeMenuKey: `sub-${sortedNewMenu[0]!.menu_item_slu![0]?.dmi_slu_id}`,
                    activeMenuData: menu[0].children[0],
                    activeSecondMenuDishes: sortedNewMenu![0].menu_item_slu![0]
                })
            })
        })
    }

    // 搜索菜品
    async onSearch(type: string, value: string, menu: any) {
        setLoading(true)
        // 可能有新增或减少菜品, 每次搜索前先获取最新的菜单数据再去搜索
        const currentMenuData = await apiManage_rbp.get_menus_v3({
            type: 0,
            with_dish: true,
            rbpSort: 1,
        })
        if (_.get(currentMenuData, 'error')) {
            setLoading(false);
            return;
        }
        if (!value) {
            this.search.isSearch = false
            this.setDefaultExpandMenu(currentMenuData, menu)
            setLoading(false)
            return
        }
        const newMenuData: FirstMenu[] = []
        let newSecond: SecondMenu[] = []
        let newDish: MenuDish[] = []

        currentMenuData.forEach((firstMenu) => {
            let isFindSecond = false;
            (firstMenu.menu_item_slu as SecondMenu[]).forEach((secondMenu) => {
                let isFindDish = false;
                (secondMenu.menu_item as MenuDish[])?.forEach((dish) => {
                    switch (type) {
                        case 'item_name1': {
                            // 匹配时转换字符串为大写
                            if (dish.item_name1?.toUpperCase().includes(value.toUpperCase())) {
                                newDish.push(dish)
                                isFindDish = true
                            }
                            break;
                        }
                        case 'item_name2': {
                            // 匹配时转换字符串为大写
                            if (dish.item_name2?.toUpperCase().includes(value.toUpperCase())) {
                                newDish.push(dish)
                                isFindDish = true
                            }
                            break;
                        }
                        case 'fast_nlu': {
                            if (this.search.fast_nlu === 2 && dish.nlu?.split('.-')[0] === value) {
                                newDish.push(dish)
                                isFindDish = true
                            } else if (this.search.fast_nlu === 1 && dish.nlu?.split('-')[0] === value) {
                                newDish.push(dish)
                                isFindDish = true
                            } else if (this.search.fast_nlu === 3 && dish.nlu === value) {
                                newDish.push(dish)
                                isFindDish = true
                            }
                        }
                    }
                })
                if (isFindDish) {
                    secondMenu.menu_item = newDish
                    newDish = []
                    isFindSecond = true
                    newSecond.push(secondMenu)
                }
            })
            if (isFindSecond) {
                firstMenu.menu_item_slu = newSecond
                newSecond = []
                newMenuData.push(firstMenu)
            }
        })
        if (newMenuData.length) {
            this.search.isSearch = true
            this.setDefaultExpandMenu(newMenuData, menu)
        }
        else {
            this.search.isSearch = true;
            GlobalNotification.warning(i18n.t('menu_dish_maker_page_no_match_for_dish'));
        }
        setLoading(false)
    }
    // TODO旧选择的菜单如果没闭合就还是展开状态
    onDragEnd = async (dropResult: DropResult, menu: FirstMenu[]) => {
        try {
            console.log(dropResult, 'dropResult', menu, 'menu')
            let _menuData = _.cloneDeep(menu);
            if (!dropResult.destination) return;
            const sourceIndex = dropResult.source.index;
            const destinationIndex = dropResult.destination.index;
            if (sourceIndex === destinationIndex) return;
            const diff = sourceIndex - destinationIndex;

            if (dropResult.draggableId.startsWith('sub')) {
                // 拖拽二级小类
                //  获取到当前拖拽的所属一级大类ID, TODO 如果获取不到就取当前高亮的一级菜单ID
                const belongToFirstMenuId = this.state.activeMenuData?.children ? this.state.activeMenuData?.key : this.state.activeMenuData?.firstMenuId;
                let foundIndex = -1;
                if (belongToFirstMenuId) {
                    const belongToFirstMenu = _menuData.find((item, index) => {
                        const isSame = Number(item.main_group_id) === Number(belongToFirstMenuId);
                        isSame && (foundIndex = index);
                        return isSame;
                    });
                    if (belongToFirstMenu) {
                        let secondMenus = belongToFirstMenu.menu_item_slu || [];
                        if (secondMenus.length) {
                            const targetId = secondMenus[sourceIndex]?.dmi_slu_id;
                            // const targetIndex = Number(menu[sourceIndex]?.main_group_index);
                            const destination = Number(secondMenus[destinationIndex]?.dmi_slu_index);
                            const toUpdateMenus: SecondMenu[] = [];
                            if (diff > 0) {
                                // 上移
                                secondMenus.forEach((item, index, arr) => {
                                    if (index >= destinationIndex && index <= sourceIndex) {
                                        index === sourceIndex ? item.dmi_slu_index = destination : item.dmi_slu_index = arr[index + 1].dmi_slu_index;
                                    }
                                    toUpdateMenus.push({
                                        dmi_slu_id: item.dmi_slu_id,
                                        dmi_slu_index: item.dmi_slu_index,
                                    });
                                })
                            } else {
                                // 下移
                                let preIndex: number = -1;
                                secondMenus.forEach((item, index) => {
                                    if (index >= sourceIndex && index <= destinationIndex) {
                                        const itemIndex = Number(item.dmi_slu_index);
                                        if (preIndex !== -1) {
                                            item.dmi_slu_index = preIndex;
                                        }
                                        preIndex = itemIndex;
                                        index === sourceIndex && (item.dmi_slu_index = destination);
                                    }
                                    toUpdateMenus.push({
                                        dmi_slu_id: item.dmi_slu_id,
                                        dmi_slu_index: item.dmi_slu_index,
                                    });
                                });
                            }
                            secondMenus = secondMenus.sort((a, b) => Number(a.dmi_slu_index) - Number(b.dmi_slu_index));
                            if (foundIndex !== -1) {

                                _menuData[foundIndex] = belongToFirstMenu;

                            }
                            // 找到一级菜单带菜品的数据
                            const originFirstMenu = this.state.menuListForSet.find(item => item.main_group_id === Number(belongToFirstMenuId));
                            const nowSecondDishId = _.get(secondMenus, destinationIndex)?.dmi_slu_id || -1;
                            const activeSecondMenuDishes = originFirstMenu?.menu_item_slu?.find(item => item.dmi_slu_id === nowSecondDishId) || {};
                            this.preMenu = _menuData;
                            this.setState({
                                menuData: _menuData,
                                activeMenuKey: `sub-${targetId}`,
                                activeMenuIndex: `[[${foundIndex}].menu_item_slu[${destinationIndex}]]`,
                                activeSecondMenuDishes: activeSecondMenuDishes as SecondMenu,
                            });
                            // $ 发起请求
                            const result = await apiManage_rbp.patch_change_second_menu_index(toUpdateMenus);
                            if (!_.get(result, 'error')) {
                                GlobalNotification.success(i18n.t('global_text_operate_success'));
                            } else {
                                GlobalNotification.error(i18n.t('global_text_operate_failure'));
                            }
                        }
                    }
                }

            } else {
                // 拖拽一级大类
                // 拖拽的目标元素
                const targetId = menu[sourceIndex]?.main_group_id;
                // const targetIndex = Number(menu[sourceIndex]?.main_group_index);
                const destination = Number(menu[destinationIndex]?.main_group_index);
                const toUpdateMenus: FirstMenu[] = [];
                if (diff > 0) {
                    // 上移
                    _menuData.forEach((item, index, arr) => {
                        if (index >= destinationIndex && index <= sourceIndex) {
                            index === sourceIndex ? item.main_group_index = destination : item.main_group_index = arr[index + 1].main_group_index;
                        }
                        toUpdateMenus.push({
                            main_group_id: item.main_group_id,
                            main_group_index: item.main_group_index,
                        });
                    });
                } else {
                    // 下移
                    let preIndex: number = -1;
                    _menuData.forEach((item, index) => {
                        if (index >= sourceIndex && index <= destinationIndex) {
                            const itemIndex = Number(item.main_group_index);
                            if (preIndex !== -1) {
                                item.main_group_index = preIndex;
                            }
                            preIndex = itemIndex;
                            index === sourceIndex && (item.main_group_index = destination);
                        }
                        toUpdateMenus.push({
                            main_group_id: item.main_group_id,
                            main_group_index: item.main_group_index,
                        });
                    });
                }
                _menuData = _menuData.sort((a, b) => Number(a.main_group_index) - Number(b.main_group_index));
                // $ 发起请求
                this.preMenu = _menuData;
                this.setState({
                    menuData: _menuData,
                    activeMenuKey: `${targetId}`,
                    activeMenuIndex: `[[${destinationIndex}]]`,
                    activeFirstMenuDishes: _.get(_menuData, destinationIndex)
                });
                const result = await apiManage_rbp.patch_change_first_menu_index(toUpdateMenus);
                if (!_.get(result, 'error')) {
                    GlobalNotification.success(i18n.t('global_text_operate_success'))
                } else {
                    this.setState({
                        menuData: menu,
                        activeMenuKey: `${targetId}`,
                        activeMenuIndex: `[[${destinationIndex}]]`,
                    });
                    GlobalNotification.error(i18n.t('global_text_operate_failure'))
                }
            }
        } catch (error) {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
    }
    /**
     * 改变排序方式
     */
    changeMenuSort = (type: number) => {
        const { activeMenuData } = this.state;
        // 左侧菜单
        const menu = this.preMenu.map((item, index) => ({
            key: `${item.main_group_id}`,
            title: item.main_group_name ?? '',
            children: (item.menu_item_slu || []).map((subMenuItem) => ({
                key: `sub-${subMenuItem.dmi_slu_id}`,
                title: subMenuItem.dmi_slu_name ?? '',
                originId: subMenuItem.dmi_slu_id ?? 0,
                dataSource: subMenuItem,
                firstMenuId: item.main_group_id,
                firstMenuIndex: index,
            })),
            dataSource: item,
        }));
        // 排序后的二级菜单
        const sortedNewMenu = type === 0 ? menu : menu.map(firstMenu => {
            firstMenu.children = firstMenu.children.sort((a, b) => {
                return (a.originId) - (b.originId)
            })
            return firstMenu
        })
        // 排序后的一级菜单
        const newMenu = type === 0 ? menu : sortedNewMenu.sort((a, b) => {
            return Number(a.key) - Number(b.key);
        });
        // 排序后的新菜单数据
        const newMenuData = newMenu.map(item => item.dataSource);
        const setState = {
            menuData: newMenuData,
            selectedItemKey: type,
        }
        // 若已点击某个菜单，则需要更新index
        if (activeMenuData) {
            let newActiveMenuIndex = '';
            if (activeMenuData?.children) {
                const newFirstMenuIndex = newMenuData.findIndex(item => item.main_group_id === Number(activeMenuData?.key));
                newActiveMenuIndex = `[[${newFirstMenuIndex}]]`
            } else if (activeMenuData?.firstMenuId) {
                const newFirstMenuIndex = newMenuData.findIndex(item => item.main_group_id === Number(activeMenuData?.firstMenuId));
                const newSecondMenuIndex = _.get(newMenuData, newFirstMenuIndex)?.menu_item_slu?.findIndex(item => item.dmi_slu_id === activeMenuData?.originId)
                newActiveMenuIndex = `[[${newFirstMenuIndex}].menu_item_slu[${newSecondMenuIndex}]]`
            }
            _.set(setState, 'activeMenuIndex', newActiveMenuIndex)
        }
        this.setState(setState, () => {
            if (this.search.isSearch) {
                this.setDefaultExpandMenu(this.preMenu, newMenu)
            }
        })
    }

    // *********************
    // View
    // *********************
    /**
     * @view_area
     * - 左侧菜单列表
     * - 详情区域
     */
    public render() {
        const {
            condimentsGroup,
            isLoading,
            taxGroup,
            menuData,
            actionKey,
            copySecondMenuToFirstMenuId,
            activeSecondMenuDishes,
            activeFirstMenuDishes,
            activeMenuIndex,
            extraMenuData,
            extraResult,
            isShowConfirmDialog,
            isShowCreateMenuDialog,
            isShowClassifyMenuLibrary,
            activeMenuKey,
            printGroup,
            majorGroup,
            mergetypes,
            priceSpecList,
            menuListForSet,
            selectedItemKey,
            isShowAllDishList,
        } = this.state;
        // 菜单排序下拉框
        const selectAction = [
            { value: 1, text: i18n.t('menu_and_dishes_page_menu_sort_value_2') },
            { value: 0, text: i18n.t('menu_and_dishes_page_menu_sort_value_1') },
        ]
        // 左侧菜单
        const menu = this.preMenu.map((item, index) => ({
            key: `${item.main_group_id}`,
            title: item.main_group_name ?? '',
            children: (item.menu_item_slu || []).map((subMenuItem) => ({
                key: `sub-${subMenuItem.dmi_slu_id}`,
                title: subMenuItem.dmi_slu_name ?? '',
                originId: subMenuItem.dmi_slu_id ?? 0,
                dataSource: subMenuItem,
                firstMenuId: item.main_group_id,
                firstMenuIndex: index,
            })),
            dataSource: item,
        }));
        // 排序后的二级菜单
        const sortedNewMenu = selectedItemKey === 0 ? menu : menu.map(firstMenu => {
            firstMenu.children = firstMenu.children.sort((a, b) => {
                return (a.originId) - (b.originId)
            })
            return firstMenu
        })
        // 排序后的一级菜单
        const newMenu = selectedItemKey === 0 ? menu : sortedNewMenu.sort((a, b) => {
            return Number(a.key) - Number(b.key);
        });
        // 右侧菜单详情
        const activeMenu: FirstMenu | SecondMenu = _.get(menuData, activeMenuIndex || '');
        return (
            <Box className='menu-dish-maker-page' hidden={isLoading}>
                <Grid container display={'flex'} flexDirection={'column'} className='menu-dish-maker-page-container'>
                    <Grid item display={'flex'} alignItems={'center'} justifyContent={'space-between'} style={{ marginBottom: '24px' }}>
                        <Box className='selected-box' display={'flex'} alignItems={'center'}>
                            <ButtonComponent
                                titleText={i18n.t('menu_and_dishes_page_all_menu_list_model')}
                                handleClick={() => {
                                    this.setState({
                                        isShowAllDishList: true,
                                    })
                                }}
                                children={i18n.t('menu_and_dishes_page_all_menu_list_model')}
                            />
                            <ButtonComponent
                                titleText={i18n.t('menu_and_dishes_page_basic_dishes_list')}
                                handleClick={() => {
                                    this.setState({
                                        isShowClassifyMenuLibrary: true,
                                    })
                                }}
                                children={i18n.t('menu_and_dishes_page_basic_dishes_list')}
                            />
                            {/* 一二级菜单排序 */}
                            <Box>
                                <BaseInput
                                    select
                                    fullWidth={false}
                                    items={selectAction.map((item) => { return { value: item.value, label: item.text } })}
                                    onChange={(e) => {
                                        const value = (e?.target?.value || 0) as number
                                        this.changeMenuSort(value);
                                    }}
                                    value={selectedItemKey}
                                />
                            </Box>
                        </Box>
                        <Box >
                            <SearchComponent
                                ref={this.searchRef}
                                selectAction={[
                                    { value: 'item_name1', text: i18n.t('menu_and_dishes_page_item_name1') },
                                    { value: 'item_name2', text: i18n.t('menu_and_dishes_page_dish_name2') },
                                    { value: 'fast_nlu', text: i18n.t('rwa_setting_page_mnemonic_code') },
                                ]}
                                onSearch={(type, value) => this.onSearch(type, value, newMenu)}
                            />
                        </Box>
                    </Grid>
                    <Grid item display={'flex'} flexDirection={'row'}>
                        {/* 菜单列表 */}
                        <Grid>
                            <MenuListComponent
                                ref={this.menuRef}
                                activeMenu={activeMenuKey}
                                menu={newMenu}
                                handleClick={(menuData, index) => { this.handleClick(menuData, index) }}
                                handleMenuClick={(key, newMenu, index) => {
                                    this.handleMenuClick(key, newMenu, index)
                                }}
                                isHideCopy={false}
                                isHideSort={selectedItemKey === 1}
                                handleOnDragEnd={this.onDragEnd}
                            />
                        </Grid >
                        <Grid item xs={12}>
                            {
                                activeMenuIndex &&
                                <div style={{ marginLeft: '24px' }} key={activeMenuIndex}>
                                    {
                                        (activeMenu as any)?.menu_item_slu
                                            ?
                                            <FirstMenuDetail
                                                key={activeFirstMenuDishes.main_group_id}
                                                menuData={menuData}
                                                detail={activeFirstMenuDishes}
                                                extraMenuData={extraMenuData}
                                                extraResult={extraResult}
                                                onChangeFirstMenu={(newMenu) => this.onChangeFirstMenu(newMenu)}
                                                onChangeDishesTurnRule={(dishes: MenuDish[]) => this.onChangeDishesTurnRule(dishes)}
                                                getMenuData={async () => {
                                                    const menuData = await this.getMenuData();
                                                    this.setState({
                                                        menuData
                                                    })
                                                }}
                                            />
                                            :
                                            activeSecondMenuDishes &&
                                            <SecondMenuDetail
                                                majorGroup={majorGroup}
                                                mergetypes={mergetypes}
                                                taxGroup={taxGroup}
                                                printGroup={printGroup}
                                                priceSpecList={priceSpecList}
                                                detail={activeSecondMenuDishes as SecondMenu}
                                                menuData={this.originMenu}
                                                menuListForSet={menuListForSet}
                                                onChangeSecondMenu={(secondMenu: SecondMenu) => this.onChangeSecondMenu(secondMenu)}
                                                onChangeDishesTurnRule={(dishes: MenuDish[]) => this.onChangeDishesTurnRule(dishes)}
                                                onChangeDishesTransfer={(dishes: MenuDish[]) => this.onChangeDishesTransfer(dishes)}
                                                onChangeDishesCopy={
                                                    (dishIds, secondMenuIds, secondMenus) => this.onChangeDishesCopy(dishIds, secondMenuIds, secondMenus)
                                                }
                                                handleDeleteDishes={(dishIds: { item_id: number, slu_id: number }[]) => this.handleDeleteDishes(dishIds)}
                                                getMenuData={async () => {
                                                    const menuData = await this.getMenuData();
                                                    this.setState({
                                                        menuData
                                                    })
                                                }}
                                                condimentsGroup={condimentsGroup}
                                            />
                                    }
                                </div>
                            }
                        </Grid >
                    </Grid>

                </Grid>
                {/* 基础菜品库弹窗 */}
                {
                    isShowClassifyMenuLibrary &&
                    <ClassifyMenuLibrary
                        open={isShowClassifyMenuLibrary}
                        onCancel={() => {
                            this.setState({
                                isShowClassifyMenuLibrary: false,
                            })
                        }}
                        getMenuData={async () => {
                            const menuData = await this.getMenuData();
                            this.setState({
                                menuData
                            })
                        }}
                        menuData={menuData}
                        taxGroup={taxGroup}
                        condimentsGroup={condimentsGroup}
                        printGroup={printGroup}
                        priceSpecList={priceSpecList}
                    />
                }
                {/* 菜品列表模式弹窗 */}
                {
                    isShowAllDishList &&
                    <AllDishList
                        open={isShowAllDishList}
                        onCancel={() => {
                            this.setState({
                                isShowAllDishList: false,
                            }, this.init)
                        }}
                        getMenuData={async () => {
                            const menuData = await this.getMenuData();
                            this.setState({
                                menuData
                            })
                        }}
                        menuListForSet={menuListForSet}
                        menuData={this.originMenu}
                        taxGroup={taxGroup}
                        condimentsGroup={condimentsGroup}
                        printGroup={printGroup}
                        priceSpecList={priceSpecList}
                        majorGroup={majorGroup}
                        mergetypes={mergetypes}
                        onChangeDishesTransfer={async (dishes: MenuDish[]) => await this.onChangeDishesTransfer(dishes, true)}
                        onChangeDishesCopy={
                            async (dishIds, secondMenuIds, secondMenus) => await this.onChangeDishesCopy(dishIds, secondMenuIds, secondMenus)
                        }
                        handleDeleteDishes={async (dishIds: { item_id: number, slu_id: number }[]) => await this.handleDeleteDishes(dishIds)}
                    />
                }
                {/* 新增菜单确认弹窗 */}
                {
                    isShowCreateMenuDialog &&
                    <DialogComponent
                        open={isShowCreateMenuDialog}
                        defaultHeaderProps={{
                            title: i18n.t('global_text_name'),
                            onClose: () => {
                                this.setState({
                                    isShowCreateMenuDialog: false
                                })
                            }
                        }}
                        fullWidth={true}
                        maxWidth={'xs'}
                        footer={
                            <div>
                                <Button
                                    color='primary'
                                    variant='outlined'
                                    onClick={() => {
                                        this.setState({
                                            isShowCreateMenuDialog: false
                                        })
                                    }}
                                >{i18n.t('google_text_public_button_cancel')}</Button>
                                <Box marginLeft={4} display='inline-block'>
                                    <Button
                                        color='primary'
                                        variant='contained'
                                        onClick={async () => {
                                            await this.handleConfirmCreateMenu()
                                        }}
                                    >{i18n.t('google_text_confirm')}</Button>
                                </Box>
                            </div>}
                    >
                        {
                            actionKey === 'COPY_SECOND' &&
                            <CommonInput
                                inputType={'SELECT'}
                                fullWidth
                                style={{ marginBottom: 10 }}
                                label={i18n.t('rwa_setting_page_first_menu')}
                                items={menuData.map(item => ({
                                    label: item.main_group_name as string,
                                    value: item.main_group_id?.toString() ?? ''
                                }))}
                                value={copySecondMenuToFirstMenuId?.toString()}
                                onChange={(event: any) => {
                                    this.setState({ copySecondMenuToFirstMenuId: Number(event.target.value) })
                                }}
                            />
                        }
                        <CommonInput
                            label={i18n.t('global_text_name')}
                            required={true}
                            regularType={'required'}
                            variant={'outlined'}
                            fullWidth
                            value={this.state.newMenuValue as any}
                            onChange={(event: any) => {
                                const value = event.currentTarget.value
                                this.setState({
                                    newMenuValue: value,
                                })
                            }}
                        />
                    </DialogComponent>
                }
                {/* 删除确认弹窗 */}
                <AlertDialog
                    {...{
                        open: isShowConfirmDialog,
                        variant: 'delete' as const,
                        title: i18n.t('tax_group_page_delete_menu'),
                        onCancel: () => { this.setState({ isShowConfirmDialog: false }); },
                        onConfirm: async () => {
                            this.setState({
                                isShowConfirmDialog: false,
                            }, async () => {
                                await this.handleConfirm()
                            })

                        },
                    }}
                />
            </Box>
        )
    }
}

export default MenuDishMakerComponent;

// ****************
// TYPE
// ****************

type Props = {};

type State = {
    // 服务器地址
    serverUrl: string;
    // 菜单数据（含菜品，供套餐选择菜品使用）
    menuListForSet: FirstMenu[];
    // 菜单数据
    menuData: FirstMenu[];
    // 选择中的二级菜单下的菜品
    activeSecondMenuDishes: SecondMenu;
    // 选择中的一级菜单下的二级菜单(含菜品)
    activeFirstMenuDishes: FirstMenu;
    // 额外费用菜单数据 菜品形式
    extraMenuData: MenuDish[];
    // 额外费用菜单数据 菜单形式
    extraResult: FirstMenu[];
    // 当前选中的菜单的位置
    activeMenuIndex?: string;
    // 当前选中的菜单
    activeMenuData?: Omit<MenuListItem, 'dataSource'>;
    // 是否显示删除确认弹框
    isShowConfirmDialog: boolean;
    // 当前点击菜单数据源
    currentMenuDataSource: MenuListItem;
    // 是否显示新增菜单确认弹框
    isShowCreateMenuDialog: boolean;
    // 是否显示基础菜品库弹窗
    isShowClassifyMenuLibrary: boolean;
    // 新增菜单名称
    newMenuValue: string;
    // 当前点击菜单下标
    currentMenuIndex: number;
    // 当前操作key值（用于区分同级新增与下级新增）
    actionKey: MENU_ACTION_TYPE | undefined,
    // 当前选中菜单key值
    activeMenuKey: string;
    // 当前选中菜单的index值
    activeMenuIndexNum: number;
    // 税率组列表
    taxGroup: TaxGroup[]
    // 加载中 初次加载时候使用
    isLoading: boolean;
    // 调味品列表
    condimentsGroup: Condiments[];
    // 菜品规格列表
    priceSpecList: ItemUnit[];
    // 打印组列表
    printGroup: any[];
    // 报表主类别
    majorGroup: any[];
    // 报表子类别
    mergetypes: any[];
    // 复制二级菜单到一级菜单的id
    copySecondMenuToFirstMenuId: number;
    // 下拉列表选择的项目
    selectedItemKey: number;
    // 全部菜品列表弹窗
    isShowAllDishList: boolean;
}
